import Priority from '../../Entities/Buildings/Priority';
import GenericNamespaceHandler from '../../GenericNamespaceHandler';

export default class PrioritiesNamespace extends GenericNamespaceHandler {
  namespace = 'buildings/priorities';

  searchCall = '';

  createCall = 'create';

  updateCall = 'update';

  deleteCall = 'delete';

  searchRequiresBuildingId = true;

  responseEntity = Priority;

  responseKey = 'option';

  requiredFields = [
    {
      param: 'building_id',
      requiredForCreate: true,
      requiredForUpdate: false,
      error: 'provide_building_id',
      validation: { type: 'int' }
    },
    {
      param: 'name',
      requiredForCreate: true,
      requiredForUpdate: false,
      error: 'invalid_travel_option_name',
      validation: { type: 'string', min: 5, max: 255 }
    },
    {
      param: 'seq',
      requiredForCreate: false,
      requiredForUpdate: false,
      validation: { type: 'int', error: 'invalid_seq' }
    }
  ];

  searchByBuildingId(
    buildingId,
    criteria = {},
    page = 1,
    orderBy,
    orderDirection
  ) {
    if (buildingId) criteria.building_id = buildingId;
    return this.search(criteria, page, orderBy, orderDirection);
  }

  create(buildingId = null, name = '', colour = '', seq = undefined) {
    const data = { building_id: buildingId, name, colour, seq };
    return super.create(data);
  }

  update(
    id = null,
    optional = { name: undefined, colour: undefined, seq: undefined }
  ) {
    return super.update(id, optional);
  }
}
